import React from 'react';
import { Platform } from 'react-native';

const Unsupported: React.ComponentType = () => {
  throw new Error(`${Platform.OS} is not supported`);
};

interface Props<WrappedProps> {
  web: React.ComponentType<WrappedProps>;
}

function MultiplatformComponent<WrappedProps>(props: Props<WrappedProps>) {
  return Platform.select({
    web: props.web,
  }) ?? Unsupported;
}

export default MultiplatformComponent;
